import { Box, Container } from '@chakra-ui/react';
import { Text } from '@chakra-ui/react';

const Explanation = ({ explanation }) =>
(
    <Box display="flex" alignItems="center" py="40px">
        <Container maxW="4xl">
        <Text fontSize="xl" align="center">{explanation}</Text>
        </Container>
    </Box>
);

export default Explanation;